import { BaseEntity } from '../core/entities/base.entity';

export class ProductEntity extends BaseEntity {
  isbn?: string;
  name?: string;
  imprint?: string;
  imprintActive?: boolean;
  changedBy?: string;
  updatedAt?: Date;
}
